import React, { Component, Fragment } from "react";

import AppContext from "../../../contexts/AppContext";

class List extends Component {
    state = {
        delete: false,
        update: false,
        details: false,
        item: {}
    };

 



    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>{this.props.item.url}</td>
                    <td>{this.props.item.link}</td>
               
                </tr>
          
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/admin/topics/List.js